<ng-container
  *ngIf="!showFallbackContent"
  [ngTemplateOutlet]="componentTemplate"
></ng-container>

<!-- Fallback Content -->
<app-fallback *ngIf="showFallbackContent"></app-fallback>
